import { values } from "lodash";
import { CompletenessApi, CompletessInfo, LegendItem } from "./types";
import { colorsComplete, colorsNotComplete } from "./constants";

export const parseAPICompleteness = (completenessApi: CompletenessApi): CompletessInfo => {
    return {
        text: CalculateTotal(completenessApi) + '%',
        colors: GetColors(completenessApi),
        legendItems: GetLegendItems(completenessApi),
        values: GetValues(completenessApi),
    }
}

function CalculateTotal(completenessApi: CompletenessApi)
{
    let total: number = 0;
    completenessApi.profileSectionCompleteness.forEach(section => {total += (section.completeLevel * section.porcentageOfTotal * 0.01)});
    return parseInt(total.toString());
}

function GetColors(completenessApi: CompletenessApi)
{
    let colors: string[] = [];
    for (let i = 0; i < completenessApi.profileSectionCompleteness.length; i++) {
        if(completenessApi.profileSectionCompleteness[i].completeLevel>0)
        {
            colors.push(colorsComplete[i]);
        }
        if(completenessApi.profileSectionCompleteness[i].completeLevel<100)
        {
            colors.push(colorsNotComplete[i]);
        }
    }
    return colors;
}

function GetLegendItems(completenessApi: CompletenessApi)
{
    let legend: LegendItem[] = [];
    for (let i = 0; i < completenessApi.profileSectionCompleteness.length; i++) {
        let color = colorsNotComplete[i];
        if(completenessApi.profileSectionCompleteness[i].completeLevel>0)
        {
            color = colorsComplete[i];
        }
        let label = completenessApi.profileSectionCompleteness[i].displayName;
        legend.push({color:color,label:label});
    }
    return legend;
}

function GetValues(completenessApi: CompletenessApi)
{
    let values: number[] = [];
    for (let i = 0; i < completenessApi.profileSectionCompleteness.length; i++) {
        if(completenessApi.profileSectionCompleteness[i].completeLevel>0)
        {
            values.push(completenessApi.profileSectionCompleteness[i].completeLevel * completenessApi.profileSectionCompleteness[i].porcentageOfTotal * 0.01);
        }
        if(completenessApi.profileSectionCompleteness[i].completeLevel<100)
        {
            values.push((100 - completenessApi.profileSectionCompleteness[i].completeLevel) * completenessApi.profileSectionCompleteness[i].porcentageOfTotal * 0.01);
        }
    }
    return values;
}
